import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import AccessScopeSection from '../AccessScopeSection';

export default function DataAccessScopes(): ReactElement {
  const { t } = useTranslation();

  return (
    <>
      <AccessScopeSection icon="recruitment_fee">
        <span>{t('FastOnboardFormJP.content2.access-scope-section1')}</span>
      </AccessScopeSection>
      <AccessScopeSection icon="institution-manual">
        <span>{t('FastOnboardFormJP.content2.access-scope-section2')}</span>
      </AccessScopeSection>
    </>
  );
}
